<template>
    <div>
      <billing-side-by-side :left="left" :right="right"></billing-side-by-side>
      <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import BillingSideBySide from "./campaigns/billing-side-by-side";

export default {
        components: {BillingSideBySide},
        props: [
            'data',
            'employerId'
        ],
        data() {
            return {
                left: this.data.left,
                right: this.data.right,
            };
        },
        methods: {
        },
    }
</script>

<style>
  .table-separator {
    border-left: solid 2px #eee;
  }
</style>
